// extracted by mini-css-extract-plugin
module.exports = {"page":"layout-module--page--3dF0K","content":"layout-module--content--7U3dF"};